import { toast } from 'react-toastify';
import { useContext, useEffect, useState } from 'react';
import { listGSTAPI ,createGst,logOutApi, deleteGSTAPI, updateGSTAPI, chnageStatusGSTAPI} from '../../../Context/api';
import axios from 'axios';
import { commonMessage, roleNames, statusCodes } from '../../../Constants/generalConfig';
import { useNavigate } from 'react-router-dom';


const useGst = () => {


    const userData = JSON.parse(localStorage.getItem('userData'))

    const navigate = useNavigate()
    // const [show, setShow] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [mode, setMode] = useState('add');
    const [editingId, setEditingId] = useState(null);
    const [listGst, setListGst] = useState();
    const [spinner, setSpinner] = useState(false)
    const [isSaving, setIsSaving] = useState(false); 
    const [formData, setFormData] = useState({
        gst:''
    })

    const [count, setCount] = useState(1)
    const [page, setPage] = useState(1)
    const PER_PAGE = 10


      // ---- modal helpers
  const openAddModal = () => {
    setMode('add');
    setEditingId(null);
    setFormData({ gst: '' });
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setMode('edit');
    setEditingId(item._id);
    setFormData({ gst: item.gst ?? '' });
    setShowModal(true);
  };

  const closeModalReset = () => {
    setShowModal(false);
    setMode('');
    setEditingId(null);
    setFormData({ gst: '' });
  };


    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev)=> ({
            ...prev,
            [name]:value
        })) 
    }


    useEffect(() => {
        if (userData == null) {
          navigate('/')
        }else{
            listApi() 
        }

      }, [page])

      const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: userData?.deviceId, userId: userData?.userId, type: userData?.roleTitle == "SERVICE_PROVIDER" ? 'WEBPROVIDER' : 'WEBSTAFF' }, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
          if (resp.data.code === statusCodes.ok) {
            localStorage.removeItem('userData')
            navigate('/')
          }
        })
      }

      const listApi = () => {
        setSpinner(true);
        const payload ={
            page: page,
            count: PER_PAGE,
        }

        // console.log('API URL:', listGSTAPI());
        axios.post(listGSTAPI(),payload, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
          if (resp.data.code === statusCodes.ok) {
            setListGst(resp.data.data)
            setCount(resp.data.totalCount)
            setSpinner(false);
            console.log(resp.data.totalCount,'resp.data.totalCount')
          }
          else if (resp.data.code === statusCodes.tokenExpire) {
            logOutFun()
          }
          else {

            setPage(1)
            setSpinner(false)
            setListGst([])
          }
        }).catch(()=>{
            setSpinner(false);
        })
      }

      const createGstApi = () => {
        const createObject = {
            gst:formData.gst
        }
        axios.post(createGst(),createObject, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
          if (resp.data.code === statusCodes.ok) {
            toast.success(resp.data.message);
            listApi()
            setSpinner(false)

          }
          else if (resp.data.code === statusCodes.tokenExpire) {
            logOutFun()
          }
          else {
    
          }
        }).catch(()=>{})
      }

      const updateGstApi = (id) => {
        const createObject = {
            gst:formData.gst,
            id:id,
        }

        axios.post(updateGSTAPI(),createObject, { headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
          if (resp.data.code === statusCodes.ok) {
            toast.success(resp.data.message);
            listApi()
            setSpinner(false)
            console.log(resp.data.message,'resp.data.message')
          }
          else if (resp.data.code === statusCodes.tokenExpire) {
            logOutFun()
          }
          else {
    
          }
        }).catch(()=>{})
      }

      const changeStatusGstApi = (id, currentStatus) => {
        console.log(currentStatus,'currentStatus')
        const createObject = {
            id:id,
            isActive:!currentStatus,
        }
        axios.post(chnageStatusGSTAPI(),createObject,{ headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
          if (resp.data.code === statusCodes.ok) {
            toast.success(resp.data.message);
            listApi()
            setSpinner(false)

          }
          else if (resp.data.code === statusCodes.tokenExpire) {
            logOutFun()
          }
          else {
    
          }
        }).catch(()=>{})
      }


      const deleteGstApi = (id) => {
        const createObject = {
            id:id,
            isDeleted:true,
        }
        axios.post(deleteGSTAPI(),createObject,{ headers: { Authorization: `Bearer ${userData?.token}` } }).then((resp) => {
          if (resp.data.code === statusCodes.ok) {
            toast.success(resp.data.message);
            listApi()
            setSpinner(false)

          }
          else if (resp.data.code === statusCodes.tokenExpire) {
            logOutFun()
          }
          else {
    
          }
        }).catch(()=>{})
      }
  

      const submitGst = async () => {
        try {
          setIsSaving(true);
          if (mode === 'add') {
            await createGstApi();
          } else {
            await updateGstApi(editingId);
          }
          closeModalReset();
        } finally {
          setIsSaving(false);
        }
      };

      return {
        listGst,
        handleChange,
        formData,
        // show,
        // setShow,
        showModal,
        setShowModal,
        createGstApi,
        deleteGstApi,
        updateGstApi,
        openAddModal,
        openEditModal,
        closeModalReset,
        mode,
        submitGst,
        isSaving,
        changeStatusGstApi,
        setPage,
        count,
        setCount,
        PER_PAGE,
        page,
        spinner
      }


}
export default useGst;